module.exports = __webpack_public_path__ + "img/pantalla2-2.eb77636f.png";